<template>
  <div class="chart-container">
    <Doughnut :data="chartData" :options="computedOptions" :plugins="centerTextPlugin" />
  </div>
</template>

<script>
import '@/services/chart-register.js';
import { Doughnut } from 'vue-chartjs';
import { CHART_COLORS } from '@/services/chart-register.js';

export default {
  name: 'BillingDoughnutChart',
  components: { Doughnut },
  props: {
    labels: { type: Array, default: function () { return []; } },
    values: { type: Array, default: function () { return []; } },
    colors: { type: Array, default: function () { return CHART_COLORS.palette; } },
    currency: { type: String, default: '' },
    centerValue: { type: String, default: '' },
    centerLabel: { type: String, default: '' }
  },
  computed: {
    centerTextPlugin: function () {
      var self = this;
      return [{
        id: 'centerText',
        afterDraw: function (chart) {
          if (!self.centerValue) return;
          var area = chart.chartArea;
          if (!area) return;
          var x = (area.left + area.right) / 2;
          var y = (area.top + area.bottom) / 2;
          var ctx = chart.ctx;
          ctx.save();
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = '#0f172a';
          ctx.font = '800 24px Inter, sans-serif';
          ctx.fillText(self.centerValue, x, y - 8);
          ctx.fillStyle = '#64748b';
          ctx.font = '600 10px Inter, sans-serif';
          ctx.fillText(self.centerLabel.toUpperCase(), x, y + 12);
          ctx.restore();
        }
      }];
    },
    chartData: function () {
      var palette = this.colors;
      return {
        labels: this.labels,
        datasets: [{
          data: this.values,
          backgroundColor: this.values.map(function (_v, i) { return palette[i % palette.length]; }),
          borderColor: CHART_COLORS.bg,
          borderWidth: 2
        }]
      };
    },
    computedOptions: function () {
      var self = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%',
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: CHART_COLORS.slate,
              font: { size: 11 },
              boxWidth: 12,
              padding: 8
            }
          },
          tooltip: {
            callbacks: {
              label: function (ctx) {
                var val = Number(ctx.parsed);
                var formatted = val.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                return ctx.label + ': ' + (self.currency || '') + formatted;
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.chart-container :deep(canvas) {
  width: 100% !important;
  height: 100% !important;
}
</style>
